export default __webpack_public_path__ + "static/media/slide_arrow_next_round.a87fb05d.svg";